export default __webpack_public_path__ + "static/stayUpToDateT-f266ca085891080af3324d9c14fc5736.png";